<div class="auth">
  <kng-loader #kngLoaderComponent [state]="loaderState"></kng-loader>
</div>
